import React from "react";
import {
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";

const SKELETON_ROW_KEYS = new Array(12)
  .fill(null)
  .map((_, index) => `order-table-skeleton-row-${index + 1}`);

const OrderTableSkeleton = () => (
  <>
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 6 }}
      data-testid="order-table-skeleton"
    >
      <Grid item>
        <Skeleton variant="text" width={100} height={24} />
      </Grid>
      <Grid item>
        <Skeleton variant="rounded" width={120} height={40} />
      </Grid>
    </Grid>

    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table sx={{ minWidth: 650 }} aria-label="orders table skeleton">
        <TableBody>
          {SKELETON_ROW_KEYS.map((rowKey) => (
            <TableRow
              key={rowKey}
              sx={{
                "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
                height: "64px",
              }}
            >
              <TableCell>
                <Skeleton variant="circular" width={16} height={16} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={120} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={100} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={150} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={140} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={80} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={60} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
);

export default OrderTableSkeleton;
